import React from 'react';

import Row from '@commons/Table/Row';
import withCondition from '@commons/withCondition';

import Anchor from '@components/RatingGrid/Anchor';
import '@components/RatingGrid/AnchorBar/anchorBar.global.scss';

export const ConditionedAnchor = withCondition(Anchor);

interface AnchorBarProps {
  anchors?: {
    caption: string;
    columnId: number;
  }[];
}

export default function AnchorBar(props: AnchorBarProps) {
  const { anchors, questionId } = props;

  const anchorElements = anchors.map(({ caption, columnId }) => (
    <ConditionedAnchor
      key={columnId}
      caption={caption}
      id={columnId}
      questionId={questionId}
      isOnFirstRow
    />
  ));

  return <Row>{anchorElements}</Row>;
}

AnchorBar.defaultProps = {
  anchors: [],
  anchorStyles: ''
};
